var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4E9C17A8-45AC-4A9D-9448-C2029A56FEDA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-financial-docs-view",
    transform: "translate(-514, -885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download-icon",
    transform: "translate(514, 885)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.575 C11.8667,15.575 11.7417,15.5542 11.625,15.5125 C11.5083,15.4708 11.4,15.4 11.3,15.3 L7.7,11.7 C7.51667,11.5167 7.425,11.2833 7.425,11 C7.425,10.7167 7.51667,10.4833 7.7,10.3 C7.88333,10.1167 8.12083,10.0208 8.4125,10.0125 C8.70417,10.0042 8.94167,10.0917 9.125,10.275 L11,12.15 L11,5 C11,4.71667 11.0958,4.47917 11.2875,4.2875 C11.4792,4.09583 11.7167,4 12,4 C12.2833,4 12.5208,4.09583 12.7125,4.2875 C12.9042,4.47917 13,4.71667 13,5 L13,12.15 L14.875,10.275 C15.0583,10.0917 15.2958,10.0042 15.5875,10.0125 C15.8792,10.0208 16.1167,10.1167 16.3,10.3 C16.4833,10.4833 16.575,10.7167 16.575,11 C16.575,11.2833 16.4833,11.5167 16.3,11.7 L12.7,15.3 C12.6,15.4 12.4917,15.4708 12.375,15.5125 C12.2583,15.5542 12.1333,15.575 12,15.575 Z M6,20 C5.45,20 4.97917,19.8042 4.5875,19.4125 C4.19583,19.0208 4,18.55 4,18 L4,16 C4,15.7167 4.09583,15.4792 4.2875,15.2875 C4.47917,15.0958 4.71667,15 5,15 C5.28333,15 5.52083,15.0958 5.7125,15.2875 C5.90417,15.4792 6,15.7167 6,16 L6,18 L18,18 L18,16 C18,15.7167 18.0958,15.4792 18.2875,15.2875 C18.4792,15.0958 18.7167,15 19,15 C19.2833,15 19.5208,15.0958 19.7125,15.2875 C19.9042,15.4792 20,15.7167 20,16 L20,18 C20,18.55 19.8042,19.0208 19.4125,19.4125 C19.0208,19.8042 18.55,20 18,20 L6,20 Z",
    id: "Shape",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.673190ae427f3bfa7b08309de7f68d42.svg";
export { ForwardRef as ReactComponent };